import React, { Component, isValidElement } from 'react';
import { observer, inject } from 'mobx-react';
import { flattenDeep, find, some, isBoolean, isNull, isEmpty, indexOf } from 'lodash';
import Exception from 'pages/common/exception';

export default (...args) => {
    const includes = find(args, isBoolean);
    const exception = some(args, isNull) ? null : find(args, isValidElement) || <Exception pageType="403" />;
    return WrappedComponent =>
        @inject('globalStore')
        @observer
        class Can extends Component {
            can = (...args) => {
                args = flattenDeep(args);
                const {
                    globalStore: {
                        accountInfo: { permissions },
                    },
                } = this.props;
                if (isEmpty(args)) {
                    return true;
                }
                for (let item of args.map(item => item + '')) {
                    if (indexOf(permissions, item) < 0) {
                        return false;
                    }
                }
                return true;
            };

            render() {
                const { can } = this;
                const {
                    globalStore: {
                        accountInfo: { permissions },
                    },
                    ...restProps
                } = this.props;
                const mergeProps = {
                    can,
                    ...restProps,
                };
                includes && Object.assign(mergeProps, { permissions });
                return can(...args) ? <WrappedComponent {...mergeProps} /> : exception;
            }
        };
};
